export default __webpack_public_path__ + "static/clear-start-20f530b95bee911ba8880aacd1686131.jpg";